<div tabindex="0" class="me-register-registration-privacy-card" *ngIf="data">
    <div class="me-register-registration-privacy-card__header">
        {{data.title}}
    </div>
    <div class="me-register-registration-privacy-card__body"  [innerHTML]="data.paragraph | storyblokRichtext">
    </div>
    <div class="me-register-registration-privacy-card__button">
        <button class="btn btn--secondary mr-1" (click)="meRegisterService.step = 1;">
            {{ 'Back' | translate}}
        </button>
        <button class="btn btn--primary" (click)="gotoNext()">
            {{ 'Continue' | translate}}
        </button>
    </div>
</div>